import { ExpandKeywordInfo } from '..';
import { Article } from '../legacy';

export enum EExperienceUnavailableReason {
  BANNED = 'banned',
  NO_ANSWER = 'no_answer',
  SERVER_ERROR = 'server_error',
}

export interface ExperienceRelatedArticle {
  items: Article[];
}

export interface ExperienceAnswerStep {
  title: string;
  content: string;
  sourceList: number[];
}

export enum EKeywordSource {
  // gsc高impr词
  gsc_high_impr = 'gsc_high_impr',
  // 拓词库
  expanded_keywords_storage = 'expanded_keywords_storage',
}

export interface ExperienceGPTAnswer {
  question: string;
  unifiedKeyword?: string;
  isNewType: boolean;
  internalLinks: ExpandKeywordInfo[];
  answerContent: ExperienceAnswerStep[];
  articleFullContent: string;
  articleShortContent: string;
  articleInfoList: Article[];
  articleGPTInfoList?: string[];
  isNumber: boolean;
  submitTimeStamp: number;
  htmlAnswerType: number;
  readCount: number;
  diggCount: number;
  commentCount: number;
  aigcTitle?: string;
  aigcDescription?: string;
}

export interface UnavailableExperienceData {
  question: string;
  unavailableReason: EExperienceUnavailableReason;
  isNewType?: boolean;
  htmlAnswerType?: number;
}
